import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsOtherNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M2 18h7.9a4.99 4.99 0 004.415-2.654l2.63-4.946a.764.764 0 011.349 0l7.5 14.1a2.788 2.788 0 004.924 0l2.612-4.913a3 3 0 012.649-1.59H46v-2H35.977a4.991 4.991 0 00-4.415 2.651L28.95 23.56a.788.788 0 01-1.393 0l-7.5-14.1a2.764 2.764 0 00-4.881 0l-2.631 4.95A2.994 2.994 0 019.9 16H2v2z"
        fill=""
      />
      <path
        d="M2 26h7.9a4.99 4.99 0 004.415-2.653l2.63-4.947a.764.764 0 011.349 0l7.5 14.1a2.789 2.789 0 004.925 0l2.612-4.913A2.993 2.993 0 0135.977 26H46v-2H35.977a4.99 4.99 0 00-4.415 2.652L28.95 31.56a.788.788 0 01-1.393 0l-7.5-14.1a2.764 2.764 0 00-4.881 0l-2.631 4.95A3 3 0 019.9 24H2v2z"
        fill=""
      />
      <path
        d="M2 34h7.9a4.99 4.99 0 004.415-2.653l2.63-4.947a.763.763 0 011.349 0l7.5 14.1a2.79 2.79 0 004.925 0l2.612-4.913A2.994 2.994 0 0135.977 34H46v-2H35.977a4.99 4.99 0 00-4.415 2.652l-2.612 4.91a.79.79 0 01-1.393 0l-7.5-14.1a2.765 2.765 0 00-4.881 0l-2.631 4.947A2.994 2.994 0 019.9 32H2v2z"
        fill=""
      />
    </svg>
  )
);
SvgSportsOtherNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsOtherNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsOtherNormalLarge;
